import { Box, CardMedia, Grid, Typography } from '@mui/material';
import React from 'react';
import './Community.css';

const Community = () => {
    const [communities, setCommunities] = React.useState([]);

    React.useEffect(() => {
        fetch(`./community.json`)
            .then(res => res.json())
            .then(data => setCommunities(data));
    }, [])
    return (
        <div>
            <Box sx={{ display: 'flex', alignItems: 'center', py: '20px' }}>
                <Box className="first-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#4741E4' }}></Box>
                <Box className="second-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#7E89FF' }}></Box>
                <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '20px', sm: '22px', md: '25px', lg: '30px' }, lineHeight: { xs: '30px', lg: '45px' }, color: '#383838', textAlign: 'left', pl: { xs: '18px', sm: '22px', md: '28px', lg: '36px' } }}>
                    Our <span style={{ fontWeight: 700, color: '#433ED1' }}>Community</span>
                </Typography>
            </Box>

            {/* all communities  */}
            <Grid container sx={{ pt: '10px', pb: { xs: '20px', md: '28px' }, px: { xl: '30px' } }}>
                {communities.map(community =>
                    <Grid item key={community.id} xs={6} sm={4}>
                        <Box className="community-hover" sx={{ display: { sm: 'flex' }, alignItems: { sm: 'center' }, py: { xs: '14px', lg: '20px' }, px: { xs: '10px', sm: '7px', lg: '28px' }, mx: { xs: '7px', lg: '17px' }, my: { xs: '12px', lg: '20px' }, background: '#FFFFFF' }}>
                            <CardMedia
                                className='set-height'
                                component="img"
                                sx={{ width: { xs: '39px', sm: '41px', md: '45px', lg: '54px' }, mx: { xs: 'auto', sm: '0' } }}
                                image={community.img}
                                alt="logo"
                            />
                            <Box sx={{ pl: { sm: '10px', md: '13px', lg: '21px' } }}>
                                <Typography sx={{ fontFamily: 'poppins', fontWeight: 400, fontSize: { xs: '10px', sm: '12px', md: '14px', lg: '16px' }, lineHeight: { xs: '15px', sm: '18px', md: '20px', lg: '24px' }, textAlign: { xs: 'center', sm: 'left' }, color: '#1B1B1B' }}>Join Our</Typography>
                                <Typography sx={{ fontFamily: 'poppins', fontWeight: 600, fontSize: { xs: '12px', sm: '13px', md: '16px', lg: '20px' }, lineHeight: { xs: '18px', sm: '22px', md: '26px', lg: '30px' }, textAlign: { xs: 'center', sm: 'left' }, color: '#433ED1' }}>{community.title}</Typography>
                            </Box>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </div >
    );
};

export default Community;